import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Solution(props) {
  return (
    <div className="services_solution  p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <div className="example" data-text="Cloud Solutions">
              <h2>
                Ease Your Business Challenges Through Serverless Computing
              </h2>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
            <p>
              Bid farewell to the limitations and complexity of traditional IT
              infrastructure and hello to a world of more productive and
              efficient operations. With our innovative serverless computing
              services, you can satisfy your company demands in a new way and
              concentrate on innovation and growth, while we take care of the
              technical details.
            </p>
            <p>
              You may distribute resources more effectively and cut expenses by
              using our serverless computing solutions, which lessen the strain
              of managing infrastructure.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Book Your Consultation!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Solution;
